import { changeItem } from './cart.js?v=30';

class CartQuantityManager extends HTMLElement {
  constructor() {
    super();
    this.controller = new AbortController();
    this.itemsContainer = null;
    this.isMainCart = null;
    this.itemNotAvailableMessage = null;
    this.itemNotAvailableMessagePlural = null;
    this.itemNotAvailableMessageSingular = null;
  }

  connectedCallback() {
    this.key = this.getAttribute('data-key');
    this.quantityEl = this.querySelector('[data-quantity]');
    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.removeBtn = this.querySelector('[data-remove]');
    this.isMainCart = this.getAttribute('data-is-main-cart') === 'true';
    this.itemsContainer = this.isMainCart
      ? document.querySelector('[data-main-cart-items]')
      : document.querySelector('[data-mobile-shopping-cart-items]');
    this.itemNotAvailableMessage = this.getAttribute('data-item-not-available-message');
    this.itemNotAvailableMessagePlural = this.getAttribute('data-item-not-available-message-plural');
    this.itemNotAvailableMessageSingular = this.getAttribute('data-item-not-available-message-singular');
    this.minusBtn?.addEventListener('click', () => this.decrease(), {
      signal: this.controller.signal,
    });
    this.plusBtn?.addEventListener('click', () => this.increase(), {
      signal: this.controller.signal,
    });
    this.removeBtn?.addEventListener('click', () => this.remove(), {
      signal: this.controller.signal,
    });

    document.addEventListener(
      'cart:success',
      () => {
        if (this.itemsContainer)
          this.itemsContainer.classList.remove(
            'pointer-events-none',
            'blur-xs',
            'opacity-50',
            'cursor-not-allowed'
          );
      },
      { signal: this.controller.signal }
    );
    document.addEventListener(
      'cart:error',
      () => {
        if (this.itemsContainer) {
          this.itemsContainer.classList.remove(
            'pointer-events-none',
            'blur-xs',
            'opacity-50',
            'cursor-not-allowed'
          );
        }
      },
      { signal: this.controller.signal }
    );
  }

  get quantity() {
    return parseInt(this.quantityEl?.textContent, 10) || 0;
  }

  async change(quantity) {
    if (this.itemsContainer)
      this.itemsContainer.classList.add(
        'pointer-events-none',
        'blur-xs',
        'opacity-50',
        'cursor-not-allowed'
      );
    const cartDetail = await changeItem(
      { key: this.key, quantity },
      this.isMainCart,
      this.itemNotAvailableMessage,
      this.itemNotAvailableMessagePlural,
      this.itemNotAvailableMessageSingular
    );

    // if only a gift wrapping product remains, auto-remove it before clearing the loading state
    if (
      cartDetail?.item_count === 1 &&
      cartDetail?.items?.some(
        (item) => item.properties['_isGiftWrapping'] === 'true'
      )
    ) {
      await changeItem(
        { key: cartDetail.items[0].key, quantity: 0 },
        this.isMainCart,
        this.itemNotAvailableMessage,
        this.itemNotAvailableMessagePlural,
        this.itemNotAvailableMessageSingular
      );
    }

    if (this.itemsContainer)
      this.itemsContainer.classList.remove(
        'pointer-events-none',
        'blur-xs',
        'opacity-50',
        'cursor-not-allowed'
      );

    this.checkTermsAndConditions(cartDetail);
  }

  checkTermsAndConditions(cartDetail = null) {
    const termsCheckbox = document.querySelector('[data-terms-label]');
    if (cartDetail?.item_count === 0) {
      sessionStorage.removeItem('terms-and-conditions-checked');
    }
    if (termsCheckbox) {
      if (sessionStorage.getItem('terms-and-conditions-checked') === 'true') {
        if (termsCheckbox.dataset.checked === 'false' || !termsCheckbox.dataset.checked ) {
          termsCheckbox.click();
        }
      }
    }
  }

  async increase() {
    await this.change(this.quantity + 1);
  }

  async decrease() {
    if (this.quantity <= 1) {
      await this.remove();
      return;
    }
    await this.change(this.quantity - 1);
  }

  async remove() {
    await this.change(0);
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get('cart-quantity-manager')) {
  customElements.define('cart-quantity-manager', CartQuantityManager);
}
